export default "__VITE_ASSET__BldAP_uW__"